var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "createorder-success-modal" },
    [
      _c("transition", { attrs: { name: "modal", duration: _vm.duration } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.show,
                expression: "show",
              },
            ],
            staticClass: "modal-container",
          },
          [
            _c(
              "div",
              {
                staticClass: "modal",
                class: _vm.alignModal,
                on: {
                  click: function ($event) {
                    if ($event.target !== $event.currentTarget) return null
                    return _vm.clickMask.apply(null, arguments)
                  },
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "modal-dialog", class: _vm.modalClass },
                  [
                    _c("div", { staticClass: "modal-content" }, [
                      _c(
                        "div",
                        { staticClass: "modal-header" },
                        [
                          _vm._t("header", function () {
                            return [
                              _c(
                                "div",
                                { staticClass: "modal-title" },
                                [_vm._t("title")],
                                2
                              ),
                              _vm.closeIconShown
                                ? _c("i", {
                                    staticClass: "ion ion-md-close close-modal",
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.cancel.apply(null, arguments)
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ]
                          }),
                        ],
                        2
                      ),
                      _c(
                        "div",
                        { staticClass: "modal-body" },
                        [_vm._t("default")],
                        2
                      ),
                      _c(
                        "div",
                        { staticClass: "modal-footer" },
                        [
                          _vm._t("footer", function () {
                            return [
                              !_vm.noButtons
                                ? _c(
                                    "button",
                                    {
                                      class: _vm.okClass,
                                      attrs: {
                                        type: "button",
                                        disabled: _vm.okDisabled,
                                      },
                                      on: { click: _vm.ok },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(_vm.okText) +
                                          "\n                "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          }),
                        ],
                        2
                      ),
                    ]),
                  ]
                ),
              ]
            ),
            _c("div", { staticClass: "modal-backdrop" }),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }